import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Globe, Phone, ChevronDown } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { Button } from "./ui/button";

const Header = () => {
  const { lang, tr, setLang, lp, langs } = useLang();
  const [open, setOpen] = useState(false);
  const [langOpen, setLangOpen] = useState(false);
  const loc = useLocation();

  const links = [
    { to: lp("/scooters"), label: tr.nav.scooters },
    { to: lp("/fauteuils-electriques"), label: tr.nav.wheelchairs },
    { to: lp("/fauteuils-roulants"), label: tr.nav.manual },
    { to: lp("/comment-ca-marche"), label: tr.nav.how },
    { to: lp("/destinations"), label: tr.nav.destinations },
    { to: lp("/tarifs"), label: tr.nav.pricing },
    { to: lp("/faq"), label: tr.nav.faq },
  ];
  const current = langs.find((l) => l.code === lang);

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-20 flex items-center justify-between gap-4">
        <Link to={lp("/")} data-testid="logo-link" className="flex items-center gap-2 shrink-0" onClick={() => setOpen(false)}>
          <span className="w-11 h-11 rounded-2xl bg-brand text-white grid place-items-center font-heading font-extrabold text-xl">M</span>
          <span className="font-heading font-extrabold text-2xl text-brand tracking-tight">MobiRider</span>
        </Link>

        <nav className="hidden xl:flex items-center gap-5 text-[15px] font-semibold text-ink-muted">
          {links.map((l) => (
            <Link key={l.to} to={l.to} className={`hover:text-brand transition-colors ${loc.pathname === l.to ? "text-brand" : ""}`}>{l.label}</Link>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <div className="relative">
            <button data-testid="lang-selector" onClick={() => setLangOpen((v) => !v)}
              className="flex items-center gap-1.5 px-3 h-11 rounded-full border-2 border-slate-200 hover:border-brand font-semibold text-sm transition-colors">
              <Globe className="w-4 h-4" /> <span>{current?.flag} {lang.toUpperCase()}</span>
              <ChevronDown className="w-4 h-4" />
            </button>
            {langOpen && (
              <div className="absolute right-0 mt-2 w-44 bg-white rounded-2xl shadow-xl border border-slate-100 overflow-hidden z-50">
                {langs.map((l) => (
                  <button key={l.code} data-testid={`lang-${l.code}`} onClick={() => { setLang(l.code); setLangOpen(false); }}
                    className={`w-full text-left px-4 py-3 text-base hover:bg-cream flex items-center gap-3 ${l.code === lang ? "font-bold text-brand" : ""}`}>
                    <span className="text-lg">{l.flag}</span> {l.label}
                  </button>
                ))}
              </div>
            )}
          </div>
          <Link to={lp("/reservation")} className="hidden sm:block">
            <Button data-testid="header-book-btn" className="rounded-full h-11 px-6 bg-accent2 hover:bg-accent2-hover text-white font-bold text-base">{tr.nav.book}</Button>
          </Link>
          <button data-testid="mobile-menu-btn" className="xl:hidden p-2" onClick={() => setOpen((v) => !v)} aria-label="Menu">
            {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="xl:hidden border-t border-slate-100 bg-white px-4 py-4 space-y-1">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="block py-3 px-2 text-lg font-semibold text-ink-muted hover:text-brand border-b border-slate-50">{l.label}</Link>
          ))}
          <Link to={lp("/reservation")} onClick={() => setOpen(false)}>
            <Button className="w-full mt-3 rounded-full h-14 bg-accent2 hover:bg-accent2-hover text-white font-bold text-lg">{tr.nav.book}</Button>
          </Link>
        </div>
      )}
    </header>
  );
};

export default Header;
